var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"tw-px-5 tw-py-5 tw-border-t tw-border-t-gray-200 tw-space-x-5"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }